import { render } from "./CookieConsent.vue?vue&type=template&id=09c98ae2"
import script from "./CookieConsent.vue?vue&type=script&lang=js"
export * from "./CookieConsent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__